import { atomWithStorage } from 'jotai/utils';

export const budgetChartState = atomWithStorage<boolean>('budgetChartState', true);